import $ from 'jquery';

$('.faq-item__question').click(function () {
    $(this).siblings('.faq-item__answer').slideToggle(200);
});
